import { render, staticRenderFns } from "./Chamado.vue?vue&type=template&id=f4b2e9fa&scoped=true&"
import script from "./Chamado.vue?vue&type=script&lang=js&"
export * from "./Chamado.vue?vue&type=script&lang=js&"
import style0 from "./Chamado.vue?vue&type=style&index=0&id=f4b2e9fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b2e9fa",
  null
  
)

export default component.exports